import { IAvatar, IMessage, IPromptTemplate } from "@/shared/types";
import { IPaginationParams, IPaginationResponse } from "@/shared/types/app";

export enum MessageType {
  DATA = "DATA",
  SERVICE = "SERVICE",
  PROMPT = "PROMPT",
}

export enum MessageStatus {
  IN_PROCESS = "IN_PROCESS",
  FINISHED = "FINISHED",
  STOPPED = "STOPPED",
  FAILED = "FAILED",
}

export enum MessageChunkType {
  START = "start",
  CHUNK = "chunk",
  END = "end",
}

export interface ISendMessageRequest {
  ai_chat_id: string;
  correlation_id: string;
  msg: string;
  type: MessageType;
  prompt_id?: string;
}

export interface IMessageChunk {
  content: string;
  message_id: string;
  status: MessageStatus;
  timestamp: number;
  type: MessageChunkType;
  dialog_id: string;
}

export interface ISendMessageParams {
  ai_chat_id: string;
  dialog_id?: string;
  msg: string;
  correlation_id: string;
  type: MessageType;
  prompt_id?: string;
}

export interface ITranscribeVoiceToTextParams {
  assistantId: string;
  audio: File;
}

export interface ITranscribeVoiceToTextResponse {
  text: string;
}

export interface IDialog {
  id: string; // assistant id
  title: string;
  description: string;
  avatar: IAvatar;
  has_dialog: boolean;
  last_dialog_id?: string;
  prompt_templates: IPromptTemplate[];
}

export interface IHistoryDialog {
  dialog_id: string;
  title: string;
  created_at: string;
  updated_at: string;
}

export interface IGetHistoryParams extends IPaginationParams {
  dialogId: string;
  cursor?: string;
}

export interface IGetHistoryResponse {
  data: IMessage[];
  next_cursor: string;
}

export interface IGetDialogsParams extends IPaginationParams {
  ai_chat_id: string;
}

export interface IGetDialogsResponse {
  data: IHistoryDialog[];
  pagination: IPaginationResponse;
}

export interface ISearchDialogsParams extends IPaginationParams {
  ai_chat_id: string;
  query: string;
}

export interface ISearchDialogsResponse extends IGetDialogsResponse {}

export interface IDeleteDialogParams {
  dialog_id: string;
}
